import { createFileRoute } from '@tanstack/react-router'

import { RedeemableFees } from '@/components/Redeem/RedeemableFees'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/$id/fees')({
  component: RedeemableFeesPage,
  head: withStaticTitle('Fees'),
})

function RedeemableFeesPage() {
  const { id } = Route.useParams()
  return <RedeemableFees redeemableId={id} />
}
